var map = {
	"./airport_united.jpg": 1005,
	"./airport_virgin.jpg": 1006
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1004;


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/img/airports ^\.\/airport_.*\.jpg$
// module id = 1004
// module chunks = 0